import '../css/my-account.scss';
import $ from '@modules/jquery-import';
import OrderHistoryController from '@modules/orders/OrderHistoryController';
import OrderItemFullDetailController from '@modules/orders/orderItemFullDetailController';
import OrderItemController from '@modules/orders/orderItemController';
import {Corpus, jqueryValidate} from '@modules/lazy-imports';
import uniq from 'ramda/src/uniq';
import {USER_NOTIF_STORE} from '@upi/constants';
import {initPasswordForms, initPasswordSuccess} from '@modules/forms/password-form';

/**
 * Initialize DOM for Page
 */
var Page = (function () {

    /** helpers **/

    // expose this object to a namespace
    return {

        nodes: {},

        init: async function () {
            await Promise.all( [jqueryValidate(), Corpus()] );
            $( this.onDOMContentLoaded );

            this.nodes.$siteContent = $( '#page-content' );
            this.nodes.userNotificationLines = document.querySelectorAll( `[data-user-notification]` );

            if ( document.getElementById( 'odr-history-container' ) ) {
                new OrderHistoryController( '#odr-history-container' );
            }

            const orderLines = document.querySelectorAll( '.js-odr-history-overview-item' );
            if ( orderLines && orderLines.length > 0 ) {
                orderLines.forEach( item =>
                    new OrderItemController( item )
                )
            }

            // exclude pending orders
            const trackedOrders = $( '[data-order-status]' ).filter( function () {
                return !/pending/.test( this.getAttribute( 'data-order-status' ) );
            } );

            if ( trackedOrders.length ) {
                this.getOrderDetails( trackedOrders );
            }

            if ( this.nodes.userNotificationLines?.length > 1 ) {
                this.initUserNotifications();
            }

            const clearNotifications = document.getElementById( 'clearAllNotifications' );
            if ( clearNotifications ) {
                clearNotifications.addEventListener( 'click', this.clearNotifications.bind( this ) );
            }
        },

        initUserNotifications () {
            let notifState = localStorage.getItem( USER_NOTIF_STORE );
            notifState = notifState !== null ? JSON.parse( notifState ) : [];

            [...this.nodes.userNotificationLines].forEach( el => {
                const notifId = el.dataset?.userNotification;

                el.addEventListener( 'click', ( e ) => {
                    notifState.push( notifId );
                    this.updateNotificationStore( notifState );
                    this.updateNotificationLine( el, notifState?.includes( notifId ) );
                } );

                this.updateNotificationLine( el, notifState?.includes( notifId ) );
            } );
        },

        clearNotifications () {
            const ids = [];
            [...this.nodes.userNotificationLines].forEach( el => {
                const notifId = el.dataset?.userNotification;
                ids.push( notifId );
                this.updateNotificationLine( el, true );
            } );
            this.updateNotificationStore( ids );
        },

        updateNotificationStore ( nextState ) {
            localStorage.setItem( USER_NOTIF_STORE, JSON.stringify( uniq( nextState ) ) );
            try {
                const notifications = JSON.parse( localStorage.getItem( USER_NOTIF_STORE ) );
                $( window ).trigger( 'notificationsUpdated', {notifications} );
            }
            catch ( err ) {
                console.error( `[Error Accessing "${USER_NOTIF_STORE}"]`, err );
            }
        },

        updateNotificationLine ( el, isViewed ) {
            if ( !el ) {
                return;
            }

            el.classList.toggle( 'notification--active', !isViewed );
        },

        onDOMContentLoaded: function () {
            initPasswordForms();
            initPasswordSuccess();
        },

        getOrderDetails: function ( trackedOrders ) {
            // initialize Order Detail module
            this.nodes.$siteContent.corpus( 'tabs', {
                controls: '.tabNavigation',
                panel: '.tabPanel',
                active_class: 'current'
            } );

            trackedOrders.each( function () {
                new OrderItemFullDetailController( this );
            } );
        }
    };
}());

$( () => Page.init() );
